import React from "react";

import { Text } from "@performyard/py-components";

import { OptionResult } from "../types";

import { calculatePercentage } from "./barChartUtils";

type SurveyResultsBarChartProps = {
	options: OptionResult[];
	totalResponses: number;
	questionType: string;
};

export function SurveyResultsBarChart({ options, totalResponses, questionType }: SurveyResultsBarChartProps) {
	return (
		<div className="flex flex-col gap-2">
			{options.map((option, index) => {
				const percentage = calculatePercentage(option.response_count, totalResponses);
				const barWidth = percentage;

				const label =
					questionType === "Rating Scale" && (option.option_value === 0 || option.option_value)
						? `${option.option_value} — ${option.option_text}`
						: option.option_text;

				return (
					<div
						key={`${option.option_text}-${option.option_value ?? index}`}
						data-testid="bar-chart-row"
						className="flex items-center gap-1"
					>
						<div className="w-14 shrink-0 text-left">
							<Text size="paragraph-3" weight="semi-bold">
								{option.response_count} ({percentage}%)
							</Text>
						</div>
						<div className="relative h-6 min-w-0 flex-1 overflow-hidden rounded bg-neutral-1">
							<div
								data-testid="bar-chart-bar"
								className="absolute inset-y-0 left-0 rounded-l bg-primary-1"
								style={{ width: `${barWidth}%` }}
							/>
							<div data-testid="bar-chart-label" className="relative truncate px-2 text-sm leading-6">
								{label}
							</div>
						</div>
					</div>
				);
			})}
		</div>
	);
}
